import { z } from "zod";
import { activityOriginTypes } from "./activity-event.schema";

/**
 * Origin context for an activity-event emission. Mirrors {@link ActorContext}
 * but classifies *what produced the event* (integration / channel / surface)
 * rather than *who*. Resolved at request time from TenantContext + caller
 * overrides; see `resolveOrigin` in `@adva/database`. ADV-919.
 */
export const OriginContextSchema = z.object({
  origin_type: z.enum(activityOriginTypes).describe("Origin Type"),
  origin_id: z.string().uuid().nullable().describe("Origin"),
});

export type OriginContext = z.infer<typeof OriginContextSchema>;
